// Remove characters that are not letters, numbers, spaces, or hyphens
export const removeSpecialChars = (str: string) => {
  return str.replace(/[^a-zA-Z0-9 -]/g, '')
}
